import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import CookieBanner from "features/landing/presentation/components/cookieBanner";
import { KroNavBar2 } from "common/layout/kroNavBar";
import { WhatsappContainer } from "common/layout/whatsappContainer";
// import WebsiteFooter from "./websiteFooter";
import Routes from "router/routes";
import KroFooter from "./kroFooter";

export default function KroLayout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const shouldHideFooter = () => {
    return (
      pathname === Routes.HOME ||
      pathname === Routes.ABOUT ||
      pathname === Routes.HOW_TO_USE ||
      pathname === Routes.CONTACT_US ||
      pathname.startsWith("/usecases/") ||
      pathname.startsWith("/blog")
    );
  };

  return (
    <>
      <div className="overflow-hidden lg:mx-auto">
        <KroNavBar2 />
        <Outlet />
        {!shouldHideFooter() && <KroFooter />}
        <WhatsappContainer />
      </div>
      <CookieBanner />
    </>
  );
}
